
import { useAnchorEl } from '@/hooks/useAnchorEl';
import { MouseEvent, useState } from 'react';
import { searchStore } from '@/shared/store/searchStore/searchStore';
import { useRouter } from 'next/navigation';
import { alertHandler } from '@/shared/utils/alertHandler';

interface useSearchBlock {
  id: number;
  getActiveSessions(): Promise<void>;
  isActive: boolean;
}

enum StatusEnum  {
  'archived' = 'архивировали',
  'deleted' = 'удалили',
  'cancelled' = 'отменили'
}


export function useSearchBlock({ id, getActiveSessions, isActive }: useSearchBlock) {
  const [anchorEl, openPopover, closePopover] = useAnchorEl();
  const [count, setCount] = useState<number>(0);
  const router = useRouter();

  function handleGoToEmpty(status: keyof typeof StatusEnum){
    router.push(`/empty`);
    searchStore.sync.setActiveSession(-1);
    alertHandler.addAlert({ status: 'warning', defaultText: `Вы ${StatusEnum[status]} активную сессию! Вы перемещены на главный экран!` });
  }

  async function handleOpenPopover(event: MouseEvent<HTMLButtonElement>, id: number) {
    openPopover(event);
    const data = await searchStore.async.fetchGetSearchBasketData(id);
    setCount(data?.length || 0);
  }
  function handleClosePopover() {
    closePopover();
  }

  async function handleCanceledSession() {
    await searchStore.async.fetchPatchCanceledSessionWithName(id, 'cancelled');
    getActiveSessions();
    handleClosePopover();
    if(isActive){
      handleGoToEmpty('cancelled');
    }
  }

  async function handleDeleteSession() {
    await searchStore.async.fetchPatchCanceledSession(id, 'deleted');
    getActiveSessions();
    handleClosePopover();
    if(isActive){
      handleGoToEmpty('deleted');
    }
  }

  async function handleArchiveSession() {
    await searchStore.async.fetchPatchCanceledSession(id, 'archived');
    getActiveSessions();
    handleClosePopover();
    if(isActive){
      handleGoToEmpty('archived');
    }
  }


  return {
    anchorEl: {
      anchorEl,
      handleOpenPopover,
      handleClosePopover,
    },
    handleCanceledSession,
    handleDeleteSession,
    handleArchiveSession,
    count
  };
}
